import { useFeatureFlags } from '@hooks/LaunchDarkly/useFeatureFlags';
import { Container, Rating } from './InlineRating.styled';
import { InlineRatingProps } from './InlineRating.types';

function InlineRating({ shipCode, isPanel = false }: Readonly<InlineRatingProps>) {
	const { enableRatingsAndReviews } = useFeatureFlags();
	const { configuration, enabled } = enableRatingsAndReviews || {};
	const showRatings = enabled && !configuration?.notAllowedShips.includes(shipCode);
	if (!showRatings) {
		return;
	}

	return (
		<Container data-panel={isPanel}>
			<Rating
				data-bv-show="inline_rating"
				data-bv-product-id={shipCode}
				onClick={(e) => {
					e.stopPropagation();
				}}
			/>
		</Container>
	);
}

export default InlineRating;
